import { api } from '@/service/http';

const getValidateResponse = response => {
    if (response.result) {
        return {
            result: response.result,
            success: !!response.result,
            data: response.data, //data может быть объектом или массивом
        };
    } else {
        return {
            result: response.result ? response.result : false,
            errors: {
                message: response.msg.message ? response.msg.message : response.msg,
            },
            uuid: response.uuid ? response.uuid : '84db0ef3-0a29-47b8-a3d1-2f6cabf4262e',
        };
    }
};
export const getEosrcCard = async eobj_id => {
    try {
        const response = await api('e-grid./eosrc/card/get', { eobj_id });
        //todo форматы ответа везде (в других функциях) сделать как тут
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '1f98743e-4194-480e-b881-9c8c71403aec',
        };
    }
};
export const updEosrcCard = async args => {
    try {
        const response = await api('e-grid./eosrc/card/upd', args);
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '3c475fbc-1e86-4c03-9eaf-89fe5ffa1ae5',
        };
    }
};

export const insEosrcCard = async args => {
    try {
        const response = await api('e-grid./eosrc/card/ins', args);
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '5a8ae802-9d07-4ed4-83d7-0f7942e18bca',
        };
    }
};

export const getSrcKind = async () => {
    try {
        const response = await api('e-grid./eosrc/dict/srckind/get');
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'af7fc9b0-020e-4779-addb-4952c7730793',
        };
    }
};
export const getSeti = async () => {
    try {
        const response = await api('e-grid./eosrc/dict/seti/get');
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'af7fc9b0-020e-4779-addb-4952c7730793',
        };
    }
};
export const getExpl = async () => {
    try {
        const response = await api('e-grid./eosrc/dict/expl/get');
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '2c013ddf-07a1-4445-acd3-e12b9232bc70',
        };
    }
};
export const getEoru = async eobj_id => {
    try {
        const response = await api('e-grid./eoru/get', { eobj_id });
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '25dfef52-89ca-4fb9-b269-e54e819bfd49',
        };
    }
};
export const getEoruHkV = async () => {
    try {
        const response = await api('e-grid./eoru/dict/hkv/get');
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'b777975a-2b5e-4e8e-b4e8-4323e7a6f8ec',
        };
    }
};

export const getEotrans = async eobj_id => {
    try {
        const response = await api('e-grid./eotrans/get', { eobj_id });
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '457d5893-cb06-4653-ab51-8e2d3e0d9b62',
        };
    }
};

export const getEofider = async eobj_id => {
    try {
        const response = await api('e-grid./eofider/get', { eobj_id });
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '4c8350ba-c608-439b-9173-e071ef2a682d',
        };
    }
};

export const getEofiderTypeline = async () => {
    try {
        const response = await api('e-grid./eofider/dict/typeline/get');
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'b777975a-2b5e-4e8e-b4e8-4323e7a6f8ec',
        };
    }
};

export const getEofiderAchr2 = async () => {
    try {
        const response = await api('e-grid./eofider/dict/achr2/get');
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '0ec18644-75d1-45b1-9fea-6fb3bda7ea0d',
        };
    }
};
export const getEofiderChapv = async () => {
    try {
        const response = await api('e-grid./eofider/dict/chapv/get');
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'c788c621-3522-4ef7-9c65-c77fed99033b',
        };
    }
};

export const getEofiderSaon = async () => {
    try {
        const response = await api('e-grid./eofider/dict/saon/get');
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '4f6ea92c-8132-45fd-9b8d-6df9f3fbb5aa',
        };
    }
};

export const getEofiderOchotkl = async () => {
    try {
        const response = await api('e-grid./eofider/dict/ochotkl/get');
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '7c25f5bf-1945-4dea-9742-71f0b7325ae7',
        };
    }
};

export const getEofiderAchr1 = async () => {
    try {
        const response = await api('e-grid./eofider/dict/achr1/get');
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '40d9c34e-cad3-4777-a345-dd58b9b24a20',
        };
    }
};

export const getEofiderSpotkl = async () => {
    try {
        const response = await api('e-grid./eofider/dict/spotkl/get');
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'dcc191e4-f8f7-46e0-b256-a3282bc6d9e2',
        };
    }
};

export const getEofiderSposobprokl = async () => {
    try {
        const response = await api('e-grid./eofider/dict/sposobprokl/get');
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'fb7fd598-2c21-4351-afc5-359cff4e880c',
        };
    }
};

export const getEofiderMatopor = async () => {
    try {
        const response = await api('e-grid./eofider/dict/matopor/get');
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '1b1dd697-9e3e-467b-83e8-2d00d98d2ca3',
        };
    }
};

export const getEofiderTor = async () => {
    try {
        const response = await api('e-grid./eofider/dict/tor/get');
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '42d6849d-a991-4337-a130-74eb8eb8245b',
        };
    }
};

export const getEoschema = async eobj_id => {
    try {
        const response = await api('e-grid./eoschema/get', { eobj_id });
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '45d545ab-5773-43bb-b648-dafd764e1d39',
        };
    }
};

export const getEoschemaFull = async eobj_id => {
    try {
        const response = await api('e-grid./eoschemafull/get', { eobj_id });
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'ed113139-b3b4-424f-a5d6-88e7ea6b82c3',
        };
    }
};
